import React from "react";
import shared from "../../styles/UserProfileCommon.module.scss";
import styles from "../../styles/admanager/UserPayPortalForm.module.scss";
import inputStyle from "../../styles/UserProfileInput.module.scss";
import { useFormFields } from "../../libs/hooksLibs";
import { validateText } from "../../utils/formUtils";
import GenericInput from "../helpers/genericInput";
import GenericDatePicker from "../helpers/genericDatePicker";
import GenericDropdown from "../helpers/genericDropdown";
import countryList from "../../constants/country_list";
import { formatUNIXTimestamp, openNewWindow } from "../../utils/helperUtils";
import { validateEmail } from "../../utils/formUtils";
import isLoggingInFromClient from "../../selectors/isLoggingInFromClient";

import { useState } from "react";
import {
  registerHyperWalletUser,
  updateHyperWalletUserInfo,
} from "../../actions/monetization";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

export default function UserPayPortalRegistration({
  isRegistered,
  setShowForm,
  showForm,
}) {
  const clientLoginState = useSelector(isLoggingInFromClient);

  const countryArray = countryList.names;
  const countryCodesArray = countryList.withCodes;
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [dateOfBirth, setDOB] = useState(new Date());
  const [checkedPolicy, setCheckPolicy] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [hasError, setHasError] = useState(false);

  const [errorStateObject, updateInputErrorState] = useFormFields({
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    email: "",
    country: "",
  });

  // useEffect(() => {
  //   if (userInfo) {
  //     console.log("userInfo", userInfo);
  //     const { firstName, lastName, email, dateOfBirth, country } = userInfo;
  //     setFirstName(firstName);
  //     setLastName(lastName);
  //     setEmail(email);
  //     setCountry(country);
  //     const dob = new Date();

  //     if (dateOfBirth) {
  //       const newString = dateOfBirth.replaceAll("-", "/");
  //       const d = Date.parse(newString);
  //       setDOB(new Date(d));
  //     }
  //   }
  // }, [userInfo]);

  function ageValidation(value) {
    // checks if user is 18 years or older
    const birthday = value.getTime();
    const now = Date.now();
    const ageDifference = now - birthday;
    const ageDate = new Date(ageDifference);
    const yearDiff = Math.abs(ageDate.getUTCFullYear() - 1970);
    let currentErrorObject = {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
    };
    if (yearDiff < 18) {
      currentErrorObject = {
        firstName: "",
        lastName: "",
        dateOfBirth:
          "Per Hyperwallets Terms, you must be 18+ years of age to create an account.",
        email: "",
      };
      setHasError(true);
      updateInputErrorState(null, currentErrorObject);
      return false;
    } else {
      setHasError(false);
      updateInputErrorState(null, currentErrorObject);
      return true;
    }
  }

  function emailValidation() {
    let currentErrorObject = {
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
    };
    if (!validateEmail(email)) {
      currentErrorObject = {
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        email: "Email format is invalid",
      };
      setHasError(true);
      updateInputErrorState(null, currentErrorObject);
      return false;
    } else {
      setHasError(false);
      updateInputErrorState(null, currentErrorObject);
      return true;
    }
  }

  function handleFieldChange(inputName, value) {
    if (inputName === "dateOfBirth") {
      ageValidation(value);
    }

    if (inputName !== "dateOfBirth") {
      if (value && validateText(value)) {
        setHasError(false);
        updateInputErrorState(inputName, false);
      } else {
        setHasError(true);
        updateInputErrorState(inputName, true);
      }
    } else {
      setDOB(value);
    }

    if (inputName === "firstName") {
      setFirstName(value.replace(/[^a-zA-Z]+/g, ""));
    } else if (inputName === "lastName") {
      setLastName(value.replace(/[^a-zA-Z]+/g, ""));
    } else if (inputName === "email") {
      setEmail(value.replace(/\s+/g, ""));
    } else if (inputName === "country") {
      setCountry(value);
    }
  }
  const handleCheckboxChange = () => {
    setCheckPolicy(!checkedPolicy);
  };
  const validateForm = (userInfo) => {
    const values = Object.values(userInfo);
    let fieldsAreValid = values.every((value) => value !== "");
    if (!fieldsAreValid) {
      const currentErrorObject = { ...errorStateObject };

      for (const key in userInfo) {
        if (key !== "dateOfBirth") {
          if (userInfo[key] === undefined || userInfo[key] === "") {
            currentErrorObject[key] = "Please provide a value";
            setHasError(true);
          } else {
            currentErrorObject[key] = "";
            setHasError(false);
          }
        }
      }

      updateInputErrorState(null, currentErrorObject);
    }

    return fieldsAreValid;
  };

  function handleFormSubmit() {
    const userInfo = {
      firstName,
      lastName,
      dateOfBirth,
      email,
      country,
    };

    if (
      !ageValidation(dateOfBirth) ||
      !emailValidation(email) ||
      !validateForm(userInfo)
    ) {
      return;
    }

    if (!checkedPolicy && !isRegistered) {
      setErrorText("Please check the policy box");
      return false;
    } else if (checkedPolicy && !isRegistered) {
      setErrorText("");
    }
    if (isRegistered) {
      dispatch(updateHyperWalletUserInfo(userInfo));
      // toast.success("dooted and booted!");
    } else {
      const formattedDate = formatUNIXTimestamp(dateOfBirth, true);

      let countryCode = countryCodesArray.find((item) => {
        return item.name === country;
      }).code;

      const registrationInfo = {
        ...userInfo,
        country: countryCode,
        dateOfBirth: formattedDate,
      };
      console.log("USER INFO ----", registrationInfo);

      dispatch(registerHyperWalletUser(registrationInfo));
    }
  }

  const openUrl = (e, url) => {
    e.preventDefault();
    if (clientLoginState) {
      openNewWindow(url, false);
    } else {
      window.open(url, "_blank");
    }
  };

  const inputStyles = {
    container: inputStyle.inputWrapper,
    label: inputStyle.inputLabel,
    input: classnames(inputStyle.genericInput, inputStyle.hyperwallet),
    error: inputStyle.error,
    errorMessage: inputStyle.errorText,
    icon: inputStyle.inputIcon,
  };
  const datePickerStyles = {
    calendarDropdownStyle: styles.calendarDropdown,
    dayStyle: styles.calendarDay,
    generalClassName: styles.calendar,
    selectedStyle: styles.selectedStyle,
    calendarError: styles.calendarError,
  };

  return (
    <div className={shared.subHeader}>
      <div className={styles.formWrapper}>
        <GenericInput
          type={"firstName"}
          title={"First Name"}
          placeholder={"First Name"}
          inputName={"firstName"}
          errorState={errorStateObject.firstName}
          errorMessage={errorStateObject.firstName}
          inputValue={firstName}
          changeCallback={handleFieldChange}
          styles={inputStyles}
        />
        <GenericInput
          type={"lastName"}
          title={"Last Name"}
          placeholder={"Last Name"}
          inputName={"lastName"}
          errorState={errorStateObject.lastName}
          errorMessage={errorStateObject.lastName}
          inputValue={lastName}
          changeCallback={handleFieldChange}
          styles={inputStyles}
        />
        <GenericDatePicker
          title={"Date of Birth"}
          inputValue={dateOfBirth}
          closeOnScroll
          errorState={errorStateObject.dateOfBirth}
          errorMessage={errorStateObject.dateOfBirth}
          handleFieldChange={(date) => handleFieldChange("dateOfBirth", date)}
          showMonthDropdown
          showYearDropdown
          datePickerStyles={datePickerStyles}
        />

        <GenericDropdown
          title={"Country"}
          inputName={"country"}
          inputValue={country}
          listItemArray={countryArray}
          changeCallback={handleFieldChange}
          errorMessage={errorStateObject.country}
          errorMessageStyle={inputStyle.dropdownErrorMessage}
          styles={{
            container: inputStyle.dropdownWrapper,
            backgroundColor: "#222222",
            color: "#D6D6D6",
            border: errorStateObject.country
              ? "1px solid #e02020"
              : "1px solid #7B7B7B",
            transition: errorStateObject.country
              ? "border-color 0.3s ease-in-out"
              : "none",
            height: "40px",
            borderRadius: "3px",
          }}
        />
        <GenericInput
          type={"email"}
          title={"Email"}
          placeholder={"Email"}
          inputName={"email"}
          errorState={errorStateObject.email}
          errorMessage={errorStateObject.email}
          inputValue={email}
          changeCallback={handleFieldChange}
          styles={inputStyles}
        />

        <button
          className={hasError ? styles.disableBtn : styles.updateBtn}
          onClick={handleFormSubmit}
        >
          {isRegistered ? "Update" : "Connect"}
        </button>
        <p className={styles.errorText}>{errorText}</p>

        {isRegistered ? (
          <div>
            <button
              className={styles.goBackBtn}
              onClick={() => setShowForm(!showForm)}
            >
              Go Back
            </button>
          </div>
        ) : (
          <div className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              id="policy"
              required
              onChange={handleCheckboxChange}
            />
            <label className={styles.checkbox} htmlFor="policy">
              <span></span>
            </label>
            <label className={styles.policyCheckbox} htmlFor="policy">
              I agree to the terms of use and the{" "}
              <button
                className={styles.policyLink}
                onClick={(e) =>
                  openUrl(e, "https://www.buildbox.com/privacy-policy/")
                }
              >
                privacy policy
              </button>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
